import '../scss/style.scss';

import './config.js';
import './mailerlite-newsletter.js';